import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { noGroup } from '@core/helpers';
import { CurrentUserService } from '@core/services';
import { UserGroupService } from '@core/services/user-group.service';
import { SidebarService } from '@layout/core/services';
import { TranslateModule } from '@ngx-translate/core';
import { EllipsisTooltipComponent } from '@shared/components';
import { TooltipFocusHandlerDirective } from '@shared/directives/tooltip-focus-handler.directive';
import { AppRoutes } from '@shared/helpers';
import { CurrentUser, UserGroup } from '@shared/interfaces';
import * as moment from 'moment';
import { ToolbarModule } from 'primeng/toolbar';
import { ToolbarComponent } from '../toolbar/toolbar.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss', './header-mobile.component.scss'],
    standalone: true,
    imports: [
        ToolbarModule,
        RouterLink,
        ToolbarComponent,
        TranslateModule,
        EllipsisTooltipComponent,
        TooltipFocusHandlerDirective,
        NgOptimizedImage,
    ],
})
export class HeaderComponent {
    readonly appRoutes = AppRoutes;
    readonly noGroup = noGroup;

    isSidebarCollapsed = true;
    currentUser: CurrentUser | null = null;
    currentGroup: UserGroup | null = null;
    redirectSettingsUrl: string = '';

    welcomeMessage = 'header.welcome';

    constructor(
        private sidebarService: SidebarService,
        private currentUserService: CurrentUserService,
        private userGroupService: UserGroupService
    ) {
        this.sidebarService.isCollapsed$.subscribe(isCollapsed => {
            this.isSidebarCollapsed = isCollapsed;
        });

        this.currentUserService.currentUser$.subscribe(user => {
            this.currentUser = user;
        });

        this.userGroupService.currentGroup$.subscribe(userGroup => {
            this.currentGroup = userGroup;
            if (this.currentGroup) {
                this.redirectSettingsUrl = this.appRoutes.routes().GROUP_SETTINGS_GENERAL(this.currentGroup.id);
            }
        });

        this.computeWelcomeMessage();
    }

    computeWelcomeMessage(): void {
        const current = moment();
        const midnight = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        const morning = moment().set({ hour: 11, minute: 59, second: 59, millisecond: 59 });
        const afternoon = moment().set({ hour: 15, minute: 59, second: 59, millisecond: 59 });
        const evening = moment().set({ hour: 23, minute: 59, second: 59, millisecond: 59 });

        if (current.isBetween(midnight, morning)) {
            this.welcomeMessage = 'header.goodMorning';
            return;
        }
        if (current.isBetween(morning, afternoon)) {
            this.welcomeMessage = 'header.goodAfternoon';
            return;
        }
        if (current.isBetween(afternoon, evening)) {
            this.welcomeMessage = 'header.goodEvening';
            return;
        }
    }
}
